import { effect, inject, Injectable } from '@angular/core';
import { SERVICE_STORE } from '@features/service/domain/tokens/service-store.token';
import { ServiceRedirectPort } from '@features/service/domain/port/service-redirect.port';

@Injectable({ providedIn: 'root' })
export class ServiceEmptyStateRedirectSubscriber {
  private readonly store = inject(SERVICE_STORE);
  private readonly redirect = inject(ServiceRedirectPort);

  constructor() {
    effect(() => {
      const state = this.store.state();

      if (state.isLoading) {
        return;
      }

      const isInitialState =
        state.locations.length === 0 &&
        state.drawers.length === 0 &&
        state.workers.length === 0 &&
        state.serviceRelations === null;

      if (isInitialState) {
        return;
      }

      const isEmpty =
        state.locations.length === 0 &&
        state.drawers.length === 0 &&
        state.workers.length === 0;

      if (isEmpty) {
        this.redirect.goToInfoService();
      }
    });
  }
}

